const FALLBACK_PUBLIC_BASE_URL = 'https://connektedin.com';

export function getPublicBaseUrl() {
  const configured = import.meta.env.VITE_PUBLIC_BASE_URL || '';
  if (configured) {
    return configured.replace(/\/$/, '');
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '');
  }

  return FALLBACK_PUBLIC_BASE_URL;
}

export function getPublicCardUrl(slug) {
  return `${getPublicBaseUrl()}/${slug}`;
}
